import React from 'react';

const SubmitButton = ({ onClick, label, disabled = false }) => {

    return (
        <button
    onClick={onClick}
    type="submit"
    disabled={disabled}
    className="relative bg-gradient-to-r from-indigo-900 via-purple-900 to-pink-800 text-white px-6 py-3 rounded-lg font-bold overflow-hidden group transition-all duration-300 shadow-xl"
>
    <span className="relative z-10">{label}</span>
    <span className="absolute inset-0 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-pulse"></span>
</button>
    );
}
export default SubmitButton;
